import { useEnvironmentContext } from "@chakra-ui/react";
import { useCallback } from "react";
export function useQueryableRoot() {
    var environment = useEnvironmentContext();
    return useCallback(function () {
        var rootNode = environment.getRootNode();
        var ownerWindow = environment.getWindow();
        if (rootNode instanceof ownerWindow.Document ||
            rootNode instanceof ownerWindow.ShadowRoot) {
            return rootNode;
        }
        throw new Error("Job Board environment root must be a Document or ShadowRoot");
    }, [environment]);
}
